/**
 * Jagger Plus — Landing Page
 * Handles: scroll reveals, sticky bar, add-to-cart with selling plans
 */
(function () {
  'use strict';

  var container = document.getElementById('jagger-plus-landing');
  if (!container) return;

  // ── Scroll reveal animations ──────────────────────────────────

  function initReveal() {
    var els = container.querySelectorAll('.jp__reveal');
    if (!els.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // Stagger children if parent has data-stagger
          var stagger = entry.target.dataset.stagger;
          if (stagger) {
            var children = entry.target.querySelectorAll('.jp__reveal');
            children.forEach(function (child, i) {
              child.style.transitionDelay = (i * 80) + 'ms';
              child.classList.add('jp--visible');
            });
          }
          entry.target.classList.add('jp--visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el) { observer.observe(el); });
  }

  // ── Sticky bar visibility ─────────────────────────────────────

  function initStickyBar() {
    var sticky = document.getElementById('jp-sticky');
    if (!sticky) return;

    var hero = container.querySelector('.jp__hero');
    var cta = container.querySelector('.jp__cta');
    var threshold = hero ? (hero.offsetTop + hero.offsetHeight * 0.6) : 500;

    function onScroll() {
      var show = window.scrollY > threshold;

      if (show && cta) {
        var ctaTop = cta.getBoundingClientRect().top;
        if (ctaTop < window.innerHeight) {
          show = false;
        }
      }

      if (show) {
        sticky.classList.add('jp-sticky--visible');
      } else {
        sticky.classList.remove('jp-sticky--visible');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // ── Plan toggle (Mensuel / Annuel) ────────────────────────────
  // Single pricing card mode: switching the toggle rewrites the unique
  // add-to-cart button's variant/selling-plan and the displayed price.

  function initPlanToggle() {
    var toggles = container.querySelectorAll('.jp__toggle');

    toggles.forEach(function (toggle) {
      var card = toggle.closest('.jp__pricing-card');
      if (!card) return;

      var btn = card.querySelector('[data-jp-toggle-btn]');
      var amountEl = card.querySelector('[data-jp-price-amount]');
      var suffixEl = card.querySelector('[data-jp-price-suffix]');
      var noteEl = card.querySelector('[data-jp-note]');
      var opts = toggle.querySelectorAll('.jp__toggle-opt');

      function applyPlan(plan) {
        if (!btn) return;
        var p = plan === 'monthly' ? 'monthly' : 'annual';

        // Rewrite the button's add-to-cart targets (read by initAddToCart)
        btn.dataset.variantId = btn.dataset[p + 'VariantId'] || '';
        btn.dataset.sellingPlanId = btn.dataset[p + 'SellingPlanId'] || '';

        // Update displayed price / suffix / note
        if (amountEl && btn.dataset[p + 'Price']) amountEl.textContent = btn.dataset[p + 'Price'];
        if (suffixEl && btn.dataset[p + 'Suffix']) suffixEl.textContent = btn.dataset[p + 'Suffix'];
        if (noteEl && typeof btn.dataset[p + 'Note'] !== 'undefined') noteEl.textContent = btn.dataset[p + 'Note'];

        // Reflect active state
        opts.forEach(function (o) {
          var active = o.dataset.jpPlan === p;
          o.classList.toggle('is-active', active);
          o.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      opts.forEach(function (opt) {
        opt.addEventListener('click', function () {
          applyPlan(opt.dataset.jpPlan);
        });
      });
    });
  }

  // ── Add to cart with selling plan ─────────────────────────────

  function initAddToCart() {
    var buttons = container.querySelectorAll('[data-jp-add-to-cart]');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();

        var variantId = btn.dataset.variantId;
        var sellingPlanId = btn.dataset.sellingPlanId;

        if (!variantId) {
          console.warn('[Jagger Plus] Missing variant ID');
          return;
        }

        btn.classList.add('jp--loading');
        btn.disabled = true;

        // Switch-aware : remplace tout abo Club déjà présent par le plan cliqué,
        // puis (r)ouvre le drawer via le re-render natif du thème.
        window.JPCart.setClubPlan(variantId, sellingPlanId)
          .then(function () {
            btn.classList.remove('jp--loading');
            btn.disabled = false;
            window.JPCart.refreshAndOpenDrawer();
          })
          .catch(function (err) {
            console.error('[Jagger Plus] Add to cart error:', err);
            btn.classList.remove('jp--loading');
            btn.disabled = false;
            window.location.href = '/cart';
          });
      });
    });
  }

  // ── Init ──────────────────────────────────────────────────────

  initReveal();
  initStickyBar();
  initPlanToggle();
  initAddToCart();
})();
